module.exports = __webpack_public_path__ + "images/emoji/red_circle.91cc8ab49896626ba941.png";